import { Text, View } from "@react-pdf/renderer";

type SignedAtSlotProps = {
  signedAtDate?: string;
};

export default function SignedAtSlot({ signedAtDate }: SignedAtSlotProps) {
  return (
    <View
      style={{
        width: "110px",
        display: "flex",
        flexDirection: "row",
        gap: "6px",
        marginRight: "7px",
        marginBottom: "7px"
      }}
    >
      {Boolean(signedAtDate) && (
        <>
          <Text
            style={{
              fontSize: "12px",
              fontFamily: "LatoRegular",
              fontWeight: "bold"
            }}
          >
            Date
          </Text>{" "}
          <Text
            style={{
              fontSize: "12px",
              fontFamily: "LatoRegular"
            }}
          >
            {signedAtDate}
          </Text>
        </>
      )}
    </View>
  );
}
